import type { GuidanceNodeType, GuidanceViewMode } from './types';

/** List-only rows in compact (summary) mode — no Gantt bar geometry. */
export const GUIDANCE_COMPACT_LIST_ROW_HEIGHT_PX = 34;

/** Session and waypoint rows keep summary bars; improvements and activities are list rows. */
export function showsGuidanceGanttBar(type: GuidanceNodeType, mode: GuidanceViewMode): boolean {
  if (mode === 'network') return false;
  if (mode === 'traditional') return true;
  return type === 'session' || type === 'waypoint';
}

export function guidanceRowHeightPx(
  type: GuidanceNodeType,
  mode: GuidanceViewMode,
  traditionalHeight = 46
): number {
  if (mode === 'network') return 0;
  if (mode === 'traditional') return traditionalHeight;
  return showsGuidanceGanttBar(type, mode) ? traditionalHeight : GUIDANCE_COMPACT_LIST_ROW_HEIGHT_PX;
}

export function guidanceBodyHeightPx(
  rows: { node: { type: GuidanceNodeType } }[],
  mode: GuidanceViewMode,
  traditionalHeight = 46
): number {
  return rows.reduce((sum, row) => sum + guidanceRowHeightPx(row.node.type, mode, traditionalHeight), 0);
}

export function showsGuidanceDependencyOverlay(mode: GuidanceViewMode): boolean {
  return mode === 'traditional';
}

export function showsGuidanceGanttChart(mode: GuidanceViewMode): boolean {
  return mode !== 'network';
}
